import React, { createContext, useContext, useState, useCallback } from 'react';

// Create the Toast context
const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({ isVisible: false, message: '' });

  // Function to show the toast
  const showToast = useCallback((message) => {
    setToast({ isVisible: true, message });
    setTimeout(() => setToast({ isVisible: false, message: '' }), 3000); // Auto-hide after 3s
  }, []);

  // Function to hide the toast
  const hideToast = useCallback(() => {
    setToast({ isVisible: false, message: '' });
  }, []);

  return (
    <ToastContext.Provider value={{ toast, showToast, hideToast }}>
      {children}
    </ToastContext.Provider>
  );
};


const Float = () => {
    const { toast, hideToast } = useToast();
  
    if (!toast.isVisible) return null;
  
    return (
      <div id="toast-success" className="z-20 fixed bottom-5 left-1/2 transform -translate-x-1/2 flex items-center justify-center w-full max-w-xs p-4 mb-4 text-gray-500 bg-gray-100 rounded-lg shadow-lg" role="alert">
        <div className="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 text-green-500 bg-green-100 rounded-lg dark:bg-green-800 dark:text-green-200">
          <svg className="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
          </svg>
        </div>
        <div className="ml-3 text-sm font-normal text-black">{toast.message}</div>
        <button
          type="button"
          onClick={hideToast}
          className="ml-auto -mx-1.5 -my-1.5 bg-white text-gray-400 hover:text-gray-900 rounded-lg focus:ring-2 focus:ring-gray-300 p-1.5 hover:bg-gray-100 inline-flex items-center justify-center h-8 w-8 "
          aria-label="Close"
        >
          <span className="sr-only">Close</span>
          <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 0 14 14">
            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
          </svg>
        </button>
      </div>
    );
  };
  
  export default Float;